<div class="layout">

  @if (isAuthenticated$ | async) {
    <!-- MOBILE OVERLAY -->
    @if (isMobileOpen) {
      <div
        class="mobile-overlay"
        (click)="closeMobile()">
      </div>
    }

    <!-- SIDEBAR -->
    <aside
      class="sidebar"
      [class.collapsed]="isCollapsed"
      [class.mobile-open]="isMobileOpen">

      <!-- HEADER -->
      <div class="sidebar-header">
        <img
          src="assets/images/logo.png"
          class="logo"
          [class.collapsed]="isCollapsed" />

        @if (!isCollapsed) {
          <span class="brand">CALIPOLI</span>
        }

        <button
          class="collapse-btn"
          (click)="toggleCollapse()"
          aria-label="Collapse sidebar">
          <i
            class="fa-solid"
            [class.fa-chevron-left]="!isCollapsed"
            [class.fa-chevron-right]="isCollapsed">
          </i>
        </button>
      </div>

      <!-- NAV -->
      <nav class="sidebar-nav">

        <!-- HOME -->
        <a
          class="nav-item"
          [routerLink]="['/dashboard']"
          routerLinkActive="active">
          <i class="fa-solid fa-house"></i>
          @if (!isCollapsed) {
            <span>
              {{ 'menu.home' | translate }}
            </span>
          }
        </a>

        <!-- COURSES (MULTI-LEVEL) -->
        <div class="nav-group">
          <button
            class="nav-item"
            (click)="toggleMenu('courses')">

            <i class="fa-solid fa-graduation-cap"></i>

            @if (!isCollapsed) {
              <span>
                {{ 'menu.course' | translate }}
              </span>
            }

            @if (!isCollapsed) {
              <i
                class="fa-solid fa-chevron-down arrow"
                [class.open]="openMenu === 'courses'">
              </i>
            }
          </button>

          @if (openMenu === 'courses' && !isCollapsed) {
            <div
              class="submenu"
              >
              <a
                [routerLink]="['/listCourses']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-book"></i>
                {{ 'menu.myCourses' | translate }}
              </a>
            </div>
          }
        </div>

        <!-- DIGITAL PRODUCTS -->
        <a
          class="nav-item"
          [routerLink]="['/listDigitalProducts']"
          routerLinkActive="active">
          <i class="fa-solid fa-box-open"></i>
          @if (!isCollapsed) {
            <span>
              {{ 'menu.digitalProducts' | translate }}
            </span>
          }
        </a>

        <!-- SUBSCRIPTIONS -->
        <div class="nav-group">
          <button
            class="nav-item"
            (click)="toggleMenu('subscriptions')">

            <i class="fa-solid fa-arrows-rotate"></i>

            @if (!isCollapsed) {
              <span>
                {{ 'menu.subscriptions' | translate }}
              </span>
            }

            @if (!isCollapsed) {
              <i
                class="fa-solid fa-chevron-down arrow"
                [class.open]="openMenu === 'subscriptions'">
              </i>
            }
          </button>

          @if (openMenu === 'subscriptions' && !isCollapsed) {
            <div
              class="submenu"
              >
              <a
                [routerLink]="['/listSubscriptions']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-layer-group"></i>
                {{ 'menu.subscriptionProducts' | translate }}
              </a>
              <a
                [routerLink]="['/listSubscriptionSubscribers']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-users"></i>
                {{ 'menu.subscriptionSubscribers' | translate }}
              </a>
            </div>
          }
        </div>

        <!-- COMMUNITY -->
        <div class="nav-group">
          <button
            class="nav-item"
            (click)="toggleMenu('community')">

            <i class="fa-solid fa-users"></i>

            @if (!isCollapsed) {
              <span>
                {{ 'menu.community' | translate }}
              </span>
            }

            @if (!isCollapsed) {
              <i
                class="fa-solid fa-chevron-down arrow"
                [class.open]="openMenu === 'community'">
              </i>
            }
          </button>

          @if (openMenu === 'community' && !isCollapsed) {
            <div class="submenu">
              <a
                [routerLink]="['/listCommunities']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-users"></i>
                {{ 'menu.myCommunities' | translate }}
              </a>
              <a
                [routerLink]="['/communityPosts']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-file-lines"></i>
                {{ 'menu.posts' | translate }}
              </a>
            </div>
          }
        </div>

        <!-- FINANCIALS -->
        <div class="nav-group">
          <button
            class="nav-item"
            (click)="toggleMenu('financials')">

            <i class="fa-solid fa-chart-line"></i>

            @if (!isCollapsed) {
              <span>
                {{ 'menu.financials.financials' | translate }}
              </span>
            }

            @if (!isCollapsed) {
              <i
                class="fa-solid fa-chevron-down arrow"
                [class.open]="openMenu === 'financials'">
              </i>
            }
          </button>

          @if (openMenu === 'financials' && !isCollapsed) {
            <div
              class="submenu"
              >
              <a
                [routerLink]="['/financials']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-book"></i>
                {{ 'menu.financials.dashboard' | translate }}
              </a>
              <a
                [routerLink]="['/stripeAccount']"
                routerLinkActive="submenu-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-brands fa-stripe"></i>
                Stripe
              </a>
            </div>
          }
        </div>

        <!-- SETTINGS -->
        <a
          class="nav-item"
          [routerLink]="['/settings']"
          routerLinkActive="active">
          <i class="fa-solid fa-gear"></i>
          @if (!isCollapsed) {
            <span>
              {{ 'menu.settings' | translate }}
            </span>
          }
        </a>

        <!-- BACK -->
        <button
          class="nav-item"
          (click)="goToCalipoli()">
          <i class="fa-solid fa-arrow-left"></i>
          @if (!isCollapsed) {
            <span>
              {{ 'menu.backToCalipoli' | translate }}
            </span>
          }
        </button>

      </nav>

      <!-- FOOTER -->
      <div class="sidebar-footer">

        <a class="icon-btn" [routerLink]="['/messages']">
          <i class="fa-regular fa-bell"></i>
        </a>

        <div class="footer-menu">
          <button
            class="icon-btn"
            type="button"
            (click)="toggleFooterMenu('language')"
            [attr.aria-expanded]="openFooterMenu === 'language'">
            <i [ngClass]="getLanguageFlag('')"></i>
          </button>

          @if (openFooterMenu === 'language') {
            <ul class="menu-list menu-list-language" [class.menu-list-collapsed]="isCollapsed">
              <li>
                <button class="menu-item" type="button" (click)="useLanguage('en')">
                  <i class="fi fi-us"></i>
                  @if (isCollapsed) {
                    <span>EN</span>
                  }
                  @else {
                    <span>English</span>
                  }
                </button>
              </li>
              <li>
                <button class="menu-item" type="button" (click)="useLanguage('pt-BR')">
                  <i class="fi fi-br"></i>
                  @if (isCollapsed) {
                    <span>BR</span>
                  }
                  @else {
                    <span>Portuguese (BR)</span>
                  }
                </button>
              </li>
              <li>
                <button class="menu-item" type="button" (click)="useLanguage('pt-PT')">
                  <i class="fi fi-pt"></i>
                  @if (isCollapsed) {
                    <span>PT</span>
                  }
                  @else {
                    <span>Portuguese (PT)</span>
                  }
                </button>
              </li>
            </ul>
          }
        </div>

        <div class="footer-menu">
          <button
            class="user-btn"
            type="button"
            (click)="toggleFooterMenu('user')"
            [attr.aria-expanded]="openFooterMenu === 'user'">
            @if (!isCollapsed) {
              <span>
                {{ (user$ | async)?.name }}
              </span>
            }
            <i class="fa-solid fa-user"></i>
          </button>

          @if (openFooterMenu === 'user') {
            <ul class="menu-list" [class.menu-list-collapsed]="isCollapsed">
              <li>
                <a class="menu-item" [routerLink]="['/user/logout']" (click)="closeFooterMenu()">
                  <i class="fa-solid fa-right-from-bracket"></i>
                  @if (isCollapsed) {
                    <span>Out</span>
                  }
                  @else {
                    <span>{{ 'menu.logout' | translate }}</span>
                  }
                </a>
              </li>
            </ul>
          }
        </div>

      </div>
    </aside>

  }
  <!-- CONTENT -->
  <main class="content">
    <router-outlet></router-outlet>
  </main>

</div>
